import AddErrorModal from './AddErrorModal';

export default AddErrorModal;
